import { TYPES_SOURCE_OPTIONS } from '@constants'
import { ActionRow, ExecuteCommandBody, FormRow, Row } from '@types'

import { executeCode } from './executeCode'
import type { ExecutionContext } from './getCommandRequestData'
import { getCommandRequestData } from './getCommandRequestData'

type BuildActionCommandRequestParams = {
  action: ActionRow
  currentRowValues: Row
  fieldsFormConfig?: FormRow[]
  scriptContext: Record<string, unknown>
  /** Доп. контекст для getCommandRequestData (например `outerSrcObj` из вложенного представления). */
  commandExecutionContext?: ExecutionContext
}

export type ActionCommandRequestData = {
  method: string
  objectCode: string
  commandCode: string
  resource?: TYPES_SOURCE_OPTIONS
  isCommandResponse: boolean
  params: Record<string, string | number | string[]>
  body: Record<string, unknown> | unknown[]
  hasFile: boolean
}

export const getActionCommandRequest = ({
  action,
  currentRowValues,
  fieldsFormConfig,
  scriptContext,
  commandExecutionContext,
}: BuildActionCommandRequestParams): ActionCommandRequestData | null => {
  const { command, jsValue } = action
  if (!command) return null

  const bindingContext: ExecutionContext = {
    ...scriptContext,
    ...commandExecutionContext,
  }

  let body: Record<string, unknown> | unknown[]
  if (jsValue) {
    const result = executeCode(jsValue, bindingContext)
    if (result === false) throw new Error('Script execution failed')
    if (result == null || typeof result !== 'object') {
      throw new Error('Script must return an object or array for body')
    }
    body = result as Record<string, unknown> | unknown[]
  } else {
    body = getCommandRequestData(
      command.body ?? [],
      currentRowValues,
      undefined,
      fieldsFormConfig,
      bindingContext
    ) as Record<string, unknown>
  }

  const hasFile =
    !Array.isArray(body) && Object.values(body).some((v): v is File => v instanceof File)

  const params = getCommandRequestData(
    command.parameters ?? [],
    currentRowValues,
    undefined,
    undefined,
    bindingContext
  )

  return {
    method: command.httpMethod,
    objectCode: command.objectCode,
    commandCode: command.name,
    resource: command.resource,
    isCommandResponse: Boolean(command.isCommandResponse),
    params,
    body: body as ExecuteCommandBody,
    hasFile,
  }
}
